import { FastlyImage } from '@components/common/image'
import React from 'react'

type Props = {
  onApply: () => void
}

/**
 * Recruitment fold rendered below the public teacher profile, above the site
 * footer. Modelled directly after the homepage MagicalCodingWorldBanner —
 * orange rounded card, white headline + CTA on the left, hero image on the
 * right with the figure overflowing the top of the card on desktop.
 *
 * The hero image is the same one used by /teach/'s first-fold so the visual
 * language stays consistent across the teacher recruitment surfaces.
 *
 * The CTA routes to /teach/ — the canonical landing page for prospective
 * teachers, which already owns the application/AuthModal flow.
 */
const BecomeTeacherCTA = ({ onApply }: Props) => (
  <div className="relative flex flex-col max-w-full px-10 mx-auto bg-orange-600 rounded-md lg:px-20 lg:flex-row lg:max-w-5xl h-full lg:h-48">
    <div className="flex flex-col justify-center w-full my-6 space-y-4 text-center text-white lg:text-left">
      <div className="text-3xl leading-tight font-700">
        Teach online to kids
        <br /> around the world
      </div>
      <button
        className="px-10 py-3 text-lg bg-white border-none lg:mr-auto rounded text-orange shadow-md font-700 focus:outline-none hover:bg-orange-100"
        onClick={onApply}
      >
        Become a teacher
      </button>
    </div>
    <div className="lg:-mt-16 flex-shrink-0">
      <FastlyImage
        alt="Teacher at desk with laptop"
        src="/images/teacher-lp/firstFold/hero.png"
        height={400}
        width={400}
      />
    </div>
  </div>
)

export default React.memo(BecomeTeacherCTA)
